"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * List of states/territories to exclude from state guides
 * These are typically US territories that don't have the same bankruptcy process as states
 */

exports.default = ["AS", "FM", "GU", "MH", "MP", "PR", "PW", "VI"];